<template>
  <div
    class="form-group wrap-drop-img"
    :class="{ focus: isHighlight }"
    @dragenter="highlight"
    @dragover="highlight"
    @dragleave="unhighlight"
    @dragover.prevent
    @drop="onDrop"
  >
    <loading
      :active.sync="isPending"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="drop-area">
      <input
        type="file"
        @change="inputChange"
        :id="idUpload"
        accept="image/*"
      />
      <label :for="idUpload">
        Tải lên hoặc kéo thả hình ảnh vào đây
      </label>
    </div>
    <div
      class="preview"
      data-id="12"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <img :src="preview" alt />
    </div>
  </div>
</template>
<script>
export default {
  name: "base-upload",
  props: {
    urlUpload: {
      type: String,
      default: "v1/upload/avatar"
    },
    idUpload: {
      default: "file-upload"
    },
    preview: {
      type: String,
      default: "/img/theme/team-1-800x800.jpg"
    }
  },
  data() {
    return {
      uploadProgress: [],
      isHighlight: false,
      isPending: false
    };
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`;
    },
    colsWithValue() {
      return row => {
        return this.columns.filter(column => this.hasValue(row, column));
      };
    }
  },
  methods: {
    highlight(e) {
      e.stopPropagation();
      e.preventDefault();
      this.isHighlight = true;
    },
    onDrop(event) {
      event.stopPropagation();
      event.preventDefault();
      this.isHighlight = false;
      let files = event.dataTransfer.files;
      if (files) {
        files = [...files];
        files.forEach(this.uploadFile);
      }
    },
    unhighlight() {
      this.isHighlight = false;
    },
    inputChange(event) {
      let files = event.target.files;
      files = [...files];
      files.forEach(this.uploadFile);
    },
    updateProgress(fileNumber, percent) {
      this.uploadProgress[fileNumber] = percent;
      let total =
        this.uploadProgress.reduce((tot, curr) => tot + curr, 0) /
        this.uploadProgress.length;
      console.debug("update", fileNumber, percent, total);
    },
    uploadFile(file) {
      this.isPending = true;
      let reader = new FileReader();
      var self = this;
      reader.readAsDataURL(file);
      reader.onloadend = function() {
        // self.preview = reader.result; //.push(reader.result);
        self.$emit("doUpload", { file: file, preview: reader.result }, () => {
          self.isPending = false;
        });
      };
    }
  }
};
</script>
<style lang="scss">
.wrap-drop-img {
  border-radius: 0.375rem;
  position: relative;
  transition: all 0.15s ease;
  background-color: #f2f2f2;
  border: 4px dashed #ccc;
  background-color: #f6f6f6;
  border-radius: 2px;
  height: 100%;
  text-align: center;
  .drop-area {
    position: absolute;
    left: 0;
    top: 0;
    padding: 5px;
    font-family: sans-serif;
    z-index: 25;
    width: 100%;
    height: 100%;
    border-radius: 50%;

    label {
      // margin-top: 40px;
      position: absolute;
      width: 100%;
      background: transparent;
      border: none;
      padding: 0;
      height: 100%;
      margin: 0;
      top: 0;
      left: 0;
      text-align: center;
      padding-top: 40px;
      cursor: pointer;
      font-size: 25px;
    }

    input {
      display: none;
    }

    &.highlight {
      border-color: purple !important;
    }
  }

  .preview {
    padding: 2px;
    border: 2px solid transparent;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    text-align: center;
    img {
      vertical-align: middle;
      width: 100%;
      object-fit: contain;
      max-height: 100%;
      position: unset;
      transform: unset;
    }
  }

  &.focus {
    border: 2px purple dashed;
  }
}
</style>
